export default __webpack_public_path__ + "static/media/icon_9.83eaf1db.png";